import { api } from "../../services";
import { $config } from "../../conf";
import { staticApi } from "../../services";
export let seminarAPI = {
  /**
   * 获取线下会信息嘉宾分类
   * @param seminarId 会议id
   * @returns {*}
   */
  guest_getGroupList({ seminarId }) {
    return api.request("/seminar/guest/getGroupList", {
      tenantId: $config.tenantId,
      seminarId,
    });
  },

  getGuest({ guestId }) {
    //https://hwuat-static.smarket.net.cn/519/seminar/2203313708240925/guest.json
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.seminarId}/${guestId}.json`
    );
  },
  file_getList({ instanceId }) {
    return api.request("/api/file/all/query", {
      instanceId,
    });
  },
  /**
   * 获取线下会分会
   * @returns {*}
   */
  getSubSeminarList() {
    // return new Promise((resolve, reject) => {
    //   staticApi
    //     .request(
    //       `/${$config.tenantId}/seminar/${$config.seminarId}/subSeminar/list.json`
    //     )
    //     .then((res) => {
    //       res.content.items.forEach((item) => {
    //         if (
    //           [
    //             "2206121017812813",
    //             "2206121671327428",
    //             "2206122230923619",
    //           ].indexOf(item.subSeminarId) >= 0
    //         ) {
    //           item.m_liveType = ["论坛"];
    //           item.m_meetingTypeCn = ["论坛"];
    //         }
    //       });
    //       resolve(res);
    //     });
    // });
    const res = staticApi.request(
      `/${$config.tenantId}/seminar/${$config.seminarId}/subSeminar/list.json`
    );
    return res;
  },
  /**
   * 获取静态数据 文章列表
   * @returns {*}
   */
  getStaticData(id) {
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.seminarId}/article/list/${id}.json`
    );
  },
  /**
   * 获取静态数据 文章列表 线上会
   * @returns {*}
   */
  getStaticData_up(id) {
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.onlineSeminarId}/article/list/${id}.json`
    );
  },
  getFile(id) {
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.seminarId}/file/list/info/${id}.json`
    );
  },
  getPartnerType() {
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.seminarId}/article/category/${$config.partnerId}.json`
    );
  },
  getPartnerList(id) {
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.seminarId}/article/list/${id}.json`
    );
  },
  getMediaType() {
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.seminarId}/article/category/${$config.mediaId}.json`
    );
  },
  /**
   * 获取线上会 分会场
   * @returns {*}
   */
  getSubSeminarList_onLine() {
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.onlineSeminarId}/subSeminar/list.json`
    );
  },
  /**
   * 获取静态数据 全局文章栏目
   * @returns {*}
   */
  getStaticArticleCategory(id) {
    return staticApi.request(
      `/${$config.tenantId}/article/category/${id}.json`
    );
  },
  /**
   * 获取静态数据 全局文章栏目 下的列表
   * @returns {*}
   */
  getStaticArticleList(id) {
    return staticApi.request(`/${$config.tenantId}/article/list/${id}.json`);
  },

  /**
   * 获取线下会单体实例
   * @returns {*}
   */
  getSeminarDeatil(id) {
    return staticApi.request(`/${$config.tenantId}/seminar/${id}/info.json`);
  },
  getSubSeminarDetail(id) {
    //https://hwuat-static.smarket.net.cn/519/seminar/2201272431369989/subSeminar/0.json
    return staticApi.request(
      `/${$config.tenantId}/seminar/${$config.onlineSeminarId}/subSeminar/${id}.json`
    );
  },
};
